module.exports = __webpack_public_path__ + "img/photo_floral.e975f208.png";